import { Maybe } from "@graphql/types";
import { DateTime } from "luxon";

export const getLocalimeFormat = (
  isoTime: string | Maybe<string> | undefined,
  format = "hh:mm a",
  zone = "utc"
) => {
  if (isoTime?.includes("AM") || isoTime?.includes("PM")) {
    return isoTime;
  }

  return getLocalTime(isoTime || "00:00:00", zone).toFormat(format);
};

export const getTimeFormat = (
  isoTime: string | Maybe<string> | undefined,
  format = "hh:mm a",
  zone = "utc"
) => {
  if (isoTime?.includes("AM") || isoTime?.includes("PM")) {
    return isoTime;
  }

  return getTime(isoTime || "00:00:00", zone).toFormat(format);
};

export const getTime = (
  isoTime: string | Maybe<string> | undefined,
  zone = "utc"
) => {
  return DateTime.fromISO(isoTime || "00:00:00", { zone });
};

export const getLocalTime = (
  isoTime: string | Maybe<string> | undefined,
  zone = "utc"
) => {
  return DateTime.fromISO(isoTime || "00:00:00", { zone }).toLocal();
};

export const convertTimeto24HourFormat = (time?: string) => {
  if (!time) return "";
  if (!is12HourFormat(time)) {
    return DateTime.fromISO(time).toFormat("HH:mm");
  }
  return DateTime.fromFormat(time, "hh:mm a").toFormat("HH:mm");
};

export const is12HourFormat = (time: string) => {
  return time.toLowerCase().includes("am") || time.toLowerCase().includes("pm");
};

export const isHhMmSsFormat = (time: string) => {
  return time.split(":").length > 2;
};

export const convertTimeTo12HourFormat = (time: string) => {
  if (is12HourFormat(time)) {
    return time;
  }

  if (isHhMmSsFormat(time)) {
    return DateTime.fromFormat(time, "HH:mm:ss").toFormat("hh:mm a");
  }

  return DateTime.fromFormat(time, "HH:mm").toFormat("hh:mm a");
};

export const showTimeIn12HourFormatFromIso = (time: string) => {
  if (is12HourFormat(time)) {
    return time;
  }
  return DateTime.fromISO(time).toFormat("hh:mm a");
};
